import { styled } from '@mui/material';
import { Link } from 'react-router-dom';

const Landing = () => (
  <Container>
    <h2>Thermia</h2>
    <Link to="/login">Login</Link>
  </Container>
);

const Container = styled('div')(() => ({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',

  '& h2': {
    margin: '1em'
  },

  '& a': {
    margin: '1em',
    alignSelf: 'center'
  }
}));

export default Landing;
